module.exports = __webpack_public_path__ + "py.dd93162b07bdbebefbae.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/py.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/py.svg
// module chunks = styles